import {
  type ConsensusThresholdCurveInput,
  type ConsensusThresholdPoint,
  createConsensusThresholdCurve,
} from './consensus-threshold-curve.js';

export interface ConsensusThresholdSeriesInput extends ConsensusThresholdCurveInput {
  readonly fromSeconds: number;
  readonly toSeconds: number;
}

/** Defaults to smoothstep presentation; choose step for exact threshold history. */
export function consensusThresholdSeries(
  input: ConsensusThresholdSeriesInput,
): ReadonlyArray<ConsensusThresholdPoint> | null {
  return createConsensusThresholdCurve(input)?.series(input.fromSeconds, input.toSeconds) ?? null;
}
